const historyStack: string[] = [];

export function addToHistory(path: string) {
  historyStack.push(path);
}

export function readHistory() {
  return historyStack as readonly string[];
}
